import React from "react"
import "./block-poster.css"

function BlockPoster({ title, subtitle }) {
  return (
    <div
      data-scroll-section
      className="section-container block-container main-block"
    >
      <div className="container-fluid container-flex">
        <h1 className="serif-2">{title}</h1>
        <p>{subtitle}</p>
      </div>
    </div>
  )
}

export default BlockPoster
